<!-- Put all the HTML HERE

    Remember: Your HTML should have only one root element
 -->
<template>
<div class="container-fluid">
    <!-- sign in -->
    <div class="row">
        <div class="container pos-r">
            <div class="user-sign-form">
                <div class="text-center">
                    <h2 class="text-green m-y">SIGN IN</h2>
                </div>
                <div class="text-center text-light">
                    <div class="form">
                        <form class="" action="index.html" method="post" id="sign-in-form">
                            <div class="form-group field">
                                <input v-model="email" placeholder="Email" type="email" class="form-control">
                            </div>
                            <div class="form-group input-group field">
                                <input v-model="password" placeholder="PASSWORD" type="password"
                                       class="form-control input-group js-input-password">
                                <a class="input-group-addon js-eye-ico" href="#">
                                    <img src="/images/icons/active_open.png" alt="Active open">
                                </a>
                                <!--<a class="input-group-addon js-eye-ico" href="#"> WHEN CLICKED-->
                                    <!--<img src="/images/icons/active_closed.png" alt="Active open">-->
                                <!--</a>-->
                                <!--<a class="input-group-addon js-eye-ico" href="#"> WHEN INPUT FOCUS-->
                                    <!--<img src="/images/icons/select_open.png" alt="Active open">-->
                                <!--</a>-->
                                <!--<a class="input-group-addon js-eye-ico" href="#"> WHEN INPUT FOCUS & CLICKED-->
                                    <!--<img src="/images/icons/select_closed.png" alt="Active open">-->
                                <!--</a>-->
                            </div>
                        </form>
                    </div>
                    <div v-if="!isProduction" class="m-t text-center">
                       <p class="text-white">OR USE YOUR</p>
                       <a href="#" class="btn btn-block btn-outline btn-gmail">GOOGLE</a>
                       <a href="#" class="btn btn-block btn-outline btn-facebook">FACEBOOK</a>
                       <a href="#" class="btn btn-block btn-outline btn-wechat">WECHAT</a>
                    </div>
                    <p class="text-lgrey text-sm m-t-md m-b-lg">
                        BY CLICKING THE BUTTON BELOW, YOU AGREE TO BLD'S <a href="javascript:void(0)" @click="goTo('/terms-of-service')">TERMS & CONDITIONS</a>
                        AND <a href="javascript:void(0)" @click="goTo('/privacy-policy')">PRIVACY POLICY</a>
                    </p>
                    <button class="btn btn-green btn-outline btn-block" type="submit">SIGN IN</button>
                    <a class="btn btn-purple btn-outline btn-block" href="signup">SIGN UP</a>
                </div>
            </div>
        </div>
    </div>
    <!-- /.sign in -->
</div>
</template>


<script>
export default {
    //        Component Name
    name: "UserComponent",
    data() {
        return {
            email: "",
            password: "",
		 isProduction: CONFIG.PRODUCTION,
        }
    },
    methods: {}
}
</script>
